export const isPartnerPortalDomain = () => {
    const host = typeof window !== 'undefined' ? window.location.host : ''
    if (!host) return false

    const partnerDomains = [
        'dev-portal.velotrax.sa',
        'portal.velotrax.sa',
        'staging-portal.velotrax.sa',
        'localhost:3001',
    ]

    // Also allow explicit partner path detection as fallback
    const pathname = typeof window !== 'undefined' ? window.location.pathname : ''
    if (pathname.startsWith('/partner/')) return true

    return partnerDomains.some(domain => host.includes(domain))
}

export const isAdminPortalDomain = () => {
    const host = typeof window !== 'undefined' ? window.location.host : ''
    if (!host) return true

    const adminDomains = [
        'dev-admin.velotrax.sa',
        'admin.velotrax.sa',
        'staging-admin.velotrax.sa',
        'localhost:3000',
    ]

    return adminDomains.some(domain => host.includes(domain)) || !isPartnerPortalDomain()
}

export const getPortalType = () => {
    if (isPartnerPortalDomain()) return 'partner'
    return 'admin'
}
